import React, { useState } from 'react';

const RecipeList = ({ recipes, onDelete, onEdit, menuItems, supplies }) => {
  const [expandedRecipeId, setExpandedRecipeId] = useState(null);

  const toggleExpand = (id) => {
    setExpandedRecipeId(expandedRecipeId === id ? null : id);
  };

  const getProductName = (productId) => {
     const pid = productId?.toString?.() || '';
     const product = Array.isArray(menuItems) ? menuItems.find(item => item.id.toString() === pid) : undefined;
     return product ? product.name : 'Producto Desconocido';
  };

  const getSupplyName = (supplyId) => {
     const sid = supplyId?.toString?.() || '';
     const supply = Array.isArray(supplies) ? supplies.find(item => item.id.toString() === sid) : undefined;
     return supply ? supply.name : 'Insumo Desconocido';
  };

  const safeNumber = (value) => {
    const num = Number(value);
    return isNaN(num) ? 0 : num;
  };

  const safeRecipes = Array.isArray(recipes)
    ? recipes.filter(r => r && (r.id || r.id === 0))
    : [];

  return (
    <div className="bg-[#F9EFD7] p-4 rounded-lg shadow mt-6">
      <h3 className="text-lg font-semibold text-[#3F1907] mb-3">Recetas Guardadas</h3>
      {safeRecipes.length === 0 ? (
        <p className="text-[#3F1907]">No hay recetas guardadas.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-[#58735A]">
            <thead className="bg-[#58735A]">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-medium text-[#F9EFD7] uppercase tracking-wider">Producto</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-[#F9EFD7] uppercase tracking-wider">Insumos</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-[#F9EFD7] uppercase tracking-wider">Cantidad</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-[#F9EFD7] uppercase tracking-wider">Costo Total</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-[#F9EFD7] uppercase tracking-wider">P.V.P. Real Total</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-[#F9EFD7] uppercase tracking-wider">Margen Total</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-[#F9EFD7] uppercase tracking-wider">Costo %</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-[#F9EFD7] uppercase tracking-wider">Acciones</th>
              </tr>
            </thead>

            <tbody className="bg-[#F9EFD7] divide-y divide-[#58735A]">

              {safeRecipes.map((recipe, index) => {

                const safeId = recipe?.id ?? index;

                const productId = recipe?.productId ?? recipe?.product_id ?? null;

                const totalCost = safeNumber(recipe?.totalCost ?? recipe?.total_cost);
                const realPVPTotal = safeNumber(recipe?.realPVPTotal ?? recipe?.real_pvp_total);
                const totalMargin = safeNumber(recipe?.totalMargin ?? recipe?.total_margin);
                const recipeCostPercentage = safeNumber(recipe?.recipeCostPercentage ?? recipe?.recipe_cost_percentage);

                const costPerServing = safeNumber(recipe?.costPerServing ?? recipe?.cost_per_serving);
                const theoreticalPVPPerServing = safeNumber(recipe?.theoreticalPVPPerServing ?? recipe?.theoretical_pvp_per_serving);
                const theoreticalPVPTotal = safeNumber(recipe?.theoreticalPVPTotal ?? recipe?.theoretical_pvp_total);
                const realPVPPerServing = safeNumber(recipe?.realPVPPerServing ?? recipe?.real_pvp_per_serving);
                const marginPerServing = safeNumber(recipe?.marginPerServing ?? recipe?.margin_per_serving);
                const totalProfitPercentage = safeNumber(recipe?.totalProfitPercentage ?? recipe?.total_profit_percentage);

                const servings = safeNumber(recipe?.servings);

                return (
                  <React.Fragment key={safeId}>
                    <tr className="hover:bg-[#F9EFD7] cursor-pointer" onClick={() => toggleExpand(safeId)}>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-[#3F1907]">{getProductName(productId)}</td>

                      <td className="px-4 py-3 whitespace-nowrap text-sm text-[#3F1907]">
                         {Array.isArray(recipe?.ingredients)
                           ? recipe.ingredients.map(ing => getSupplyName(ing?.supplyId ?? ing?.supply_id)).join(', ')
                           : 'N/A'}
                      </td>

                      <td className="px-4 py-3 whitespace-nowrap text-sm text-[#3F1907]">
                         {Array.isArray(recipe?.ingredients)
                           ? recipe.ingredients.map(ing => safeNumber(ing?.quantity)).join(', ')
                           : 'N/A'}
                      </td>

                      <td className="px-4 py-3 whitespace-nowrap text-sm text-[#3F1907]">${totalCost.toFixed(2)}</td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-[#3F1907]">${realPVPTotal.toFixed(2)}</td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-[#3F1907]">${totalMargin.toFixed(2)}</td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-[#3F1907]">{recipeCostPercentage.toFixed(2)}%</td>

                      <td className="px-4 py-3 whitespace-nowrap text-sm text-[#3F1907] space-x-2">
                        <button
                          onClick={(e) => { e.stopPropagation(); onEdit(recipe); }}
                          className="text-blue-500 hover:text-blue-700 transition duration-200"
                        >
                          Editar
                        </button>

                        <button
                          onClick={(e) => { e.stopPropagation(); onDelete(recipe.id); }}
                          className="text-red-500 hover:text-red-700 transition duration-200"
                        >
                          Eliminar
                        </button>
                      </td>
                    </tr>

                    {expandedRecipeId === safeId && (
                      <tr>
                        <td colSpan="8" className="px-4 py-3 bg-[#F9EFD7]">
                          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 text-sm text-[#3F1907]">

                            <div>
                              <p><span className="font-semibold">Raciones:</span> {servings}</p>
                              <p><span className="font-semibold">Costo por Ración:</span> ${costPerServing.toFixed(2)}</p>
                              <p><span className="font-semibold">P.V.P. Teórico por Ración:</span> ${theoreticalPVPPerServing.toFixed(2)}</p>
                            </div>

                            <div>
                              <p><span className="font-semibold">P.V.P. Teórico Total:</span> ${theoreticalPVPTotal.toFixed(2)}</p>
                              <p><span className="font-semibold">P.V.P. Real por Ración (sin IVA):</span> ${realPVPPerServing.toFixed(2)}</p>
                              <p><span className="font-semibold">P.V.P. Real Total:</span> ${realPVPTotal.toFixed(2)}</p>
                            </div>

                            <div>
                              <p><span className="font-semibold">Margen de Utilidad por Ración:</span> ${marginPerServing.toFixed(2)}</p>
                              <p><span className="font-semibold">Margen de Utilidad Total:</span> ${totalMargin.toFixed(2)}</p>
                              <p><span className="font-semibold">Porcentaje de Utilidad Total:</span> {totalProfitPercentage.toFixed(2)}%</p>
                              <p><span className="font-semibold">Porcentaje de Costo de la Receta:</span> {recipeCostPercentage.toFixed(2)}%</p>
                            </div>

                          </div>
                        </td>
                      </tr>
                    )}

                  </React.Fragment>
                );

              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default RecipeList;